"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _googleMapsReact = require("google-maps-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _googleMapDarkTheme = _interopRequireDefault(require("./google-map-dark-theme.json"));
var _googleMapStandardTheme = _interopRequireDefault(require("./google-map-standard-theme.json"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var GoogleMap = function GoogleMap(_ref) {
  var google = _ref.google,
    selectedIndex = _ref.selectedIndex,
    markers = _ref.markers,
    updateActiveDay = _ref.updateActiveDay,
    dark = _ref.dark,
    isMobile = _ref.isMobile,
    mapWrapperWidth = _ref.mapWrapperWidth;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    mapInstance = _useState2[0],
    setMapInstance = _useState2[1];
  (0, _react.useEffect)(function () {
    if (mapInstance) {
      mapInstance.fitBounds(bounds);
      if (!isMobile) offsetMap(mapInstance);
    }
  }, [mapInstance, selectedIndex]);
  var mapEl = (0, _react.useRef)(null);
  var theme = _googleMapStandardTheme["default"];
  if (dark) theme = _googleMapDarkTheme["default"];

  // Create map bounds from all markers
  var bounds = new google.maps.LatLngBounds();
  var latLngBounds = markers.map(function (_ref2) {
    var lat = _ref2.lat,
      lng = _ref2.lng;
    return {
      lat: +lat,
      lng: +lng
    };
  });
  latLngBounds.forEach(function (marker) {
    bounds.extend(marker);
  });

  // Thank god for this... in their example they are doing offset from the left side if ever needed in the future:
  // https://stackoverflow.com/questions/25992521/show-direction-between-two-points-in-google-map-api-with-a-padding/26192440#26192440

  var overlayWidth = mapWrapperWidth / 2;
  var fromLatLngToPoint = function fromLatLngToPoint(latLng) {
    var scale = Math.pow(2, mapInstance.getZoom()); // apparently same as Math.pow(2, mapInstance.getZoom());
    var nw = new google.maps.LatLng(mapInstance.getBounds().getNorthEast().lat(), mapInstance.getBounds().getSouthWest().lng());
    var worldCoordinateNW = mapInstance.getProjection().fromLatLngToPoint(nw);
    var worldCoordinate = mapInstance.getProjection().fromLatLngToPoint(latLng);
    return new google.maps.Point(Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale), Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale));
  };
  var offsetMap = function offsetMap(map) {
    if (bounds !== false) {
      // Top right corner
      var topRightCorner = new google.maps.LatLng(map.getBounds().getNorthEast().lat(), map.getBounds().getNorthEast().lng());

      // Top right point
      var topRightPoint = fromLatLngToPoint(topRightCorner).x;

      // Get pixel position of leftmost and rightmost points
      var leftCoords = bounds.getSouthWest();
      var leftMost = fromLatLngToPoint(leftCoords).x;
      var rightMost = fromLatLngToPoint(bounds.getNorthEast()).x;

      // Calculate left and right offsets
      var leftOffset = leftMost;
      var rightOffset = overlayWidth - (topRightPoint - rightMost);

      // Only if right offset is needed
      if (rightOffset >= 0) {
        if (rightOffset < leftOffset) {
          var mapOffset = Math.round((leftOffset - rightOffset) / 2);
          // Pan the map by the offset calculated on the x axis
          map.panBy(mapOffset, 0);
          offsetMap(map);
        } else {
          // Cannot offset map at this zoom level otherwise both leftmost and rightmost points will not fit
          // Zoom out and offset map again
          map.setZoom(map.getZoom() - 1);
          offsetMap(map);
        }
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_googleMapsReact.Map, {
    ref: mapEl,
    google: google,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    onReady: function onReady(mapProps, map) {
      map.fitBounds(bounds);
      google.maps.event.addListenerOnce(map, 'idle', function () {
        setMapInstance(map);
      });
    },
    styles: theme
  }, markers && markers.map(function (m, i) {
    return /*#__PURE__*/_react["default"].createElement(_googleMapsReact.Marker, {
      key: JSON.stringify(m),
      title: m.title,
      position: {
        lat: parseFloat(m.lat),
        lng: parseFloat(m.lng)
      },
      icon: selectedIndex === i ? {
        url: 'https://cdn.theyachtweek.com/assets/map-marker.svg'
      } : {
        url: 'https://cdn.theyachtweek.com/assets/map-marker-unselected.svg'
      },
      onClick: function onClick() {
        updateActiveDay(i);
        console.log(selectedIndex);
      },
      zIndex: selectedIndex === i ? 1000 : 0
    });
  }));
};
GoogleMap.propTypes = {
  google: _propTypes["default"].object.isRequired,
  selectedIndex: _propTypes["default"].number,
  markers: _propTypes["default"].array,
  updateActiveDay: _propTypes["default"].func,
  dark: _propTypes["default"].bool,
  isMobile: _propTypes["default"].bool,
  mapWrapperWidth: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = (0, _googleMapsReact.GoogleApiWrapper)({
  apiKey: 'AIzaSyDu24LHw_eOpnobo8f35T9COSol1T9TrIY'
})(GoogleMap);